let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iDsCS")).then(() => parcelRequire('9Z3tz'));